/**
 * FHB clean upsell -- opt-in popup + per-item cart row version.
 *
 * Nothing is ever added to the cart automatically. Two moments ask:
 *   1. Right after adding an eligible used pair to the cart -- one popup,
 *      about that one pair.
 *   2. A small row attached directly under each eligible pair in the cart
 *      items list (sections/main-cart-items.liquid renders an empty
 *      .fhb-item-clean-host per line; this file decides what, if anything,
 *      goes in it). Checking the box adds that pair's clean immediately;
 *      unchecking removes it. A pair that already has a clean shows a plain
 *      confirmation instead of a checkbox. This replaced an earlier
 *      "reminder box above the subtotal" design -- attaching the option to
 *      each product directly reads clearer with several pairs in cart.
 *
 * The fee and which FRIED HARD CLEAN variant to buy for each pair are both
 * computed in Liquid (snippets/fhb-clean-upsell.liquid) -- this file only
 * reads that and acts on explicit clicks. It never guesses a price and never
 * adds anything on its own.
 */
(function () {
  'use strict';

  if (window.__fhbCleanUpsellStarted) return;
  window.__fhbCleanUpsellStarted = true;

  var SELECTOR = '[data-fhb-clean-upsell]';
  var MY_SECTION = 'fhb-clean-upsell';
  var HOST_ID = 'fhb-clean-upsell-host';
  var HOST_CLASS = 'fhb-clean-upsell-host';
  var ITEM_HOST_CLASS = 'fhb-item-clean-host';
  var MAX_RETRIES = 2;

  var COPY = {
    add: {
      eyebrow: 'Before you keep shopping',
      standardHeadline: "Want us to clean these before we ship them?",
      standardDesc: "We hand-clean the upper, refresh the midsole, and treat scuffs and creasing based on this pair's condition.",
      touchUpHeadline: 'Add a quick touch-up before we ship these?',
      touchUpDesc: 'This pair is already in great shape — a light touch-up: fresh laces, a quick wipe-down, and spot-cleaning any light scuffs.',
      yes: 'Yes, add the clean',
      no: 'No thanks'
    },
    item: {
      standard: { label: 'Add Fried Hard Clean', sub: 'Upper, midsole & lace refresh for this pair' },
      touchUp: { label: 'Add quick touch-up', sub: 'Fresh laces, wipe-down & light scuff spot-clean' },
      already: 'Fried Hard Clean already added'
    }
  };

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function readState() {
    var el = document.querySelector(SELECTOR);
    if (!el) return null;
    var script = el.querySelector('[data-fhb-clean-state]');
    if (!script) return null;
    var raw;
    try {
      raw = JSON.parse(script.textContent);
    } catch (error) {
      console.error('[fhb-clean] could not parse cart state', error);
      return null;
    }
    return {
      pairs: raw.pairs || [],
      cleans: raw.cleans || [],
      askedAdd: (raw.askedAdd || '').split(',').filter(Boolean)
    };
  }

  function findClean(state, pairId) {
    return state.cleans.filter(function (c) { return c.pairId === pairId; })[0] || null;
  }

  function findPairToAskOnAdd(state) {
    var candidates = state.pairs.filter(function (p) {
      return !findClean(state, p.id) && state.askedAdd.indexOf(p.id) === -1;
    });
    // Last candidate is assumed to be the one most recently added -- Shopify
    // appends new lines to the end of cart.items.
    return candidates.length ? candidates[candidates.length - 1] : null;
  }

  function sectionsToRender() {
    var list = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items) list.push({ hostId: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    if (footer) list.push({ hostId: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    list.push({ hostId: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return list;
  }

  function applyFhbSectionHtml(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('#' + HOST_ID);
    if (!parsed) return;
    document.querySelectorAll('.' + HOST_CLASS).forEach(function (host) {
      host.innerHTML = parsed.innerHTML;
    });
  }

  function swapSections(state) {
    if (!state || !state.sections) return;
    sectionsToRender().forEach(function (entry) {
      var host = document.getElementById(entry.hostId);
      var html = state.sections[entry.section];
      if (!host || !html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(entry.selector);
      if (!parsed) return;
      var target = host.querySelector(entry.selector) || host;
      target.innerHTML = parsed.innerHTML;
    });
    applyFhbSectionHtml(state.sections[MY_SECTION]);
    syncItemRows(readState());
  }

  function post(url, body, withSections, attempt) {
    attempt = attempt || 0;
    if (withSections) {
      body.sections = sectionsToRender().map(function (s) { return s.section; }).concat([MY_SECTION]);
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.status === 429 && attempt < MAX_RETRIES) {
        return new Promise(function (resolve) {
          setTimeout(resolve, 1200 * (attempt + 1));
        }).then(function () {
          return post(url, body, false, attempt + 1);
        });
      }
      return response.json();
    });
  }

  function refreshSection() {
    return fetch(route('cart_url', '/cart') + '?section_id=' + MY_SECTION)
      .then(function (response) { return response.text(); })
      .then(applyFhbSectionHtml)
      .catch(function (error) {
        console.error('[fhb-clean] section refresh failed', error);
      });
  }

  function markAskedAdd(pairId) {
    var state = readState();
    if (!state) return Promise.resolve();
    var list = state.askedAdd.slice();
    if (list.indexOf(pairId) === -1) list.push(pairId);
    return post(route('cart_update_url', '/cart/update'), { attributes: { _fhb_clean_asked_add: list.join(',') } }, true).then(swapSections);
  }

  function addCleanForPair(pair) {
    if (!pair.variantId) {
      console.error('[fhb-clean] no FRIED HARD CLEAN variant matched fee $' + pair.fee + ' for pair', pair.id);
      return Promise.resolve();
    }
    return post(route('cart_add_url', '/cart/add'), {
      items: [{ id: pair.variantId, quantity: 1, properties: { 'For': pair.label, '_pair_id': pair.id } }]
    }, true).then(swapSections);
  }

  // Removes a clean line by its cart line key (not variant id -- the same
  // FRIED HARD CLEAN variant/fee can be in the cart more than once for
  // different pairs, so only the line key uniquely identifies which one).
  function removeCleanForPair(clean) {
    if (!clean || !clean.key) return Promise.resolve();
    return post(route('cart_change_url', '/cart/change'), { id: clean.key, quantity: 0 }, true).then(swapSections);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  // ---- Add popup (single pair) ----

  var addOverlay, addEyebrow, addThumb, addName, addSize,
    addHeadline, addDesc, addPrice, addYesBtn, addNoBtn;

  function buildAddModal() {
    addOverlay = document.createElement('div');
    addOverlay.className = 'fhb-modal-overlay';
    addOverlay.innerHTML =
      '<div class="fhb-modal">' +
        '<div class="fhb-modal-eyebrow"></div>' +
        '<div class="fhb-modal-product">' +
          '<div class="fhb-modal-thumb" aria-hidden="true">👟</div>' +
          '<div>' +
            '<div class="fhb-modal-name"></div>' +
            '<div class="fhb-modal-size"></div>' +
          '</div>' +
        '</div>' +
        '<h3 class="fhb-modal-headline"></h3>' +
        '<p class="fhb-modal-desc"></p>' +
        '<div class="fhb-modal-price-line">' +
          '<span class="fhb-modal-price-label">Fried Hard Clean</span>' +
          '<span class="fhb-modal-price-amount"></span>' +
        '</div>' +
        '<div class="fhb-modal-actions">' +
          '<button type="button" class="fhb-modal-yes"></button>' +
          '<button type="button" class="fhb-modal-no"></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(addOverlay);

    addEyebrow = addOverlay.querySelector('.fhb-modal-eyebrow');
    addThumb = addOverlay.querySelector('.fhb-modal-thumb');
    addName = addOverlay.querySelector('.fhb-modal-name');
    addSize = addOverlay.querySelector('.fhb-modal-size');
    addHeadline = addOverlay.querySelector('.fhb-modal-headline');
    addDesc = addOverlay.querySelector('.fhb-modal-desc');
    addPrice = addOverlay.querySelector('.fhb-modal-price-amount');
    addYesBtn = addOverlay.querySelector('.fhb-modal-yes');
    addNoBtn = addOverlay.querySelector('.fhb-modal-no');
  }

  function isAnyModalOpen() {
    return !!(addOverlay && addOverlay.classList.contains('is-active'));
  }

  function showAddPopup(pair) {
    if (isAnyModalOpen()) return;
    if (!addOverlay) buildAddModal();

    var c = COPY.add;
    var headline = pair.touchUp ? c.touchUpHeadline : c.standardHeadline;
    var desc = pair.touchUp ? c.touchUpDesc : c.standardDesc;

    addEyebrow.textContent = c.eyebrow;
    addName.textContent = pair.label;
    addSize.textContent = pair.size;
    addHeadline.textContent = headline;
    addDesc.textContent = desc;
    addPrice.textContent = '$' + pair.fee;
    addYesBtn.textContent = c.yes;
    addNoBtn.textContent = c.no;
    addYesBtn.disabled = false;
    addNoBtn.disabled = false;

    addYesBtn.onclick = function () {
      if (addYesBtn.disabled) return;
      addYesBtn.disabled = true;
      addNoBtn.disabled = true;
      addCleanForPair(pair).then(function () { return markAskedAdd(pair.id); }).then(function () {
        addOverlay.classList.remove('is-active');
      });
    };
    addNoBtn.onclick = function () {
      if (addNoBtn.disabled) return;
      addYesBtn.disabled = true;
      addNoBtn.disabled = true;
      markAskedAdd(pair.id).then(function () {
        addOverlay.classList.remove('is-active');
      });
    };

    addOverlay.classList.add('is-active');
  }

  // ---- Per-item cart row (lives directly under each eligible pair) ----

  function renderItemHost(host, pair, clean) {
    if (!pair) {
      host.innerHTML = '';
      return;
    }

    if (clean) {
      host.innerHTML =
        '<div class="fhb-item-clean fhb-item-clean--done">' +
          '<span class="fhb-item-clean-check" aria-hidden="true">✓</span>' +
          '<span>' + escapeHtml(COPY.item.already) + ' — $' + pair.fee + '</span>' +
        '</div>';
      return;
    }

    var copy = pair.touchUp ? COPY.item.touchUp : COPY.item.standard;
    host.innerHTML =
      '<label class="fhb-item-clean">' +
        '<input type="checkbox" class="fhb-item-clean-check-input">' +
        '<span class="fhb-item-clean-icon" aria-hidden="true">🧼</span>' +
        '<span class="fhb-item-clean-text">' +
          escapeHtml(copy.label) +
          '<span class="fhb-item-clean-sub">' + escapeHtml(copy.sub) + '</span>' +
        '</span>' +
        '<span class="fhb-item-clean-fee">$' + pair.fee + '</span>' +
      '</label>';

    var checkbox = host.querySelector('.fhb-item-clean-check-input');
    checkbox.onchange = function () {
      if (checkbox.disabled) return;
      checkbox.disabled = true;
      if (checkbox.checked) {
        addCleanForPair(pair);
      }
    };
  }

  function syncItemRows(state) {
    var hosts = document.querySelectorAll('.' + ITEM_HOST_CLASS);
    if (!hosts.length) return;
    hosts.forEach(function (host) {
      if (!state) {
        host.innerHTML = '';
        return;
      }
      var variantId = host.dataset.lineVariantId;
      var pair = state.pairs.filter(function (p) { return p.id === variantId; })[0] || null;
      var clean = pair ? findClean(state, pair.id) : null;
      renderItemHost(host, pair, clean);
    });
  }

  // Unchecking an already-added clean's row needs its own listener since
  // that row is rendered as a plain confirmation (renderItemHost above),
  // not a checkbox -- clicking it removes the clean and reverts to the
  // checkbox state.
  document.addEventListener('click', function (event) {
    var doneRow = event.target.closest('.fhb-item-clean--done');
    if (!doneRow) return;
    var host = doneRow.closest('.' + ITEM_HOST_CLASS);
    if (!host) return;
    var state = readState();
    if (!state) return;
    var variantId = host.dataset.lineVariantId;
    var pair = state.pairs.filter(function (p) { return p.id === variantId; })[0];
    if (!pair) return;
    var clean = findClean(state, pair.id);
    if (!clean) return;
    doneRow.classList.add('is-removing');
    removeCleanForPair(clean);
  });

  // ---- Triggers ----

  function checkForAddPopup() {
    if (isAnyModalOpen()) return;
    var state = readState();
    if (!state) return;
    var pair = findPairToAskOnAdd(state);
    if (pair) showAddPopup(pair);
  }

  function start() {
    checkForAddPopup();
    syncItemRows(readState());

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(function () {
          refreshSection().then(function () {
            checkForAddPopup();
            syncItemRows(readState());
          });
        }, 0);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
